import { render } from "./CategorizedShopView.vue?vue&type=template&id=a54d6b64&scoped=true"
import script from "./CategorizedShopView.vue?vue&type=script&lang=js"
export * from "./CategorizedShopView.vue?vue&type=script&lang=js"

import "./CategorizedShopView.vue?vue&type=style&index=0&id=a54d6b64&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a54d6b64"]])

export default __exports__